/**
 * Down sampling.
 */
export enum Downsampling {
  /** No down sampling. */
  None = 1,
  /** Half resolution down sampling. */
  TwoX = 2,
  /** Quarter resolution down sampling. */
  FourX = 4
}
